import React, { useEffect } from "react";
import Header from "../components/header";

import "./style/imprint.css";
import SubPageHeader from "../components/subPageHeader";
import { disableLoader } from "../components/loader";

function ImprintPage() {

    useEffect(() => {
        disableLoader();
    })
    return <div id="imprint">
        <SubPageHeader title="Imprint"/>
        <div className="text">
            <h2>Represented by Andrea Cicalese</h2>
            <p>E-mail: <a href="mailto:info@andrea-cicalese.com">info@andrea-cicalese.com</a></p>
        </div>
    </div>;
}

export default ImprintPage;